import { inject, prop } from "fw";
import { formatDuration } from "helpers/duration-formatter";

export enum DurationType {
    Tick = 1,
    Millisecond = 2,
    Seconds = 3
}

@inject
export class Duration {
    @prop(null) private duration!: number;
    @prop(DurationType.Millisecond) private type: DurationType;

    get formatted() {
        return formatDuration(this.duration, this.type);
    }
}
